import React from "react";
import { useTheme } from "../../middleware/ThemeContext";

interface AddIconProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const DnsIcon: React.FC<AddIconProps> = ({ size = 22, color = '#003366', className, onClick }) => {
  const { theme } = useTheme();
  color = theme.name === 'light' ? color : '#ffffff';
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.1654 11.9166V10.9999C20.1654 5.93731 16.0613 1.83325 10.9987 1.83325C5.93609 1.83325 1.83203 5.93731 1.83203 10.9999C1.83203 13.0637 2.51445 14.9678 3.66536 16.4999" stroke={color} strokeWidth="1.375" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11.918 1.87817C11.918 1.87817 14.668 5.49958 14.668 10.9995V11.9163" stroke={color} strokeWidth="1.375" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.082 1.87817C10.082 1.87817 7.33203 5.49958 7.33203 10.9995V11.9163" stroke={color} strokeWidth="1.375" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2.41016 14.2083H3.6661" stroke={color} strokeWidth="1.375" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2.41016 7.79175H19.5892" stroke={color} strokeWidth="1.375" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.41797 20.1667V14.6667H7.33464C8.34716 14.6667 9.16797 15.4875 9.16797 16.5001V18.3334C9.16797 19.346 8.34716 20.1667 7.33464 20.1667H6.41797Z" stroke={color} strokeWidth="1.375" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11.918 20.1667V14.6667L14.668 20.1667V14.6667" stroke={color} strokeWidth="1.375" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M17.418 20.1667H19.2513C20.0107 20.1667 20.6263 19.5511 20.6263 18.7917C20.6263 18.0324 20.0107 17.4167 19.2513 17.4167H18.793C18.0336 17.4167 17.418 16.8011 17.418 16.0417C17.418 15.2824 18.0336 14.6667 18.793 14.6667H20.168" stroke={color} strokeWidth="1.375" strokeLinecap="round" strokeLinejoin="round" />
    </svg>


  );
};

export default DnsIcon;